import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36b44fc1")

_pushScopeId("data-v-36b44fc1")
const _hoisted_1 = { class: "report" }
const _hoisted_2 = { class: "topbox" }
const _hoisted_3 = { class: "member clearfix" }
const _hoisted_4 = { class: "img fl" }
const _hoisted_5 = { class: "info fl" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "info fl" }
const _hoisted_8 = { class: "datainfo" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "val" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "name" }, "检测日期", -1)
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "val" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "name" }, "报告日期", -1)
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "val" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "%", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "name" }, "有效数据", -1)
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "title bgblue subpadding" }, [
  /*#__PURE__*/_createVNode("div", { class: "t" }, "中医心藏功能态势测评报告")
], -1)
const _hoisted_21 = { class: "card" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "title bgblue subpadding" }, [
  /*#__PURE__*/_createVNode("div", { class: "t" }, "中医肝藏功能态势测评报告")
], -1)
const _hoisted_23 = { class: "card" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "title bgblue subpadding" }, [
  /*#__PURE__*/_createVNode("div", { class: "t" }, "中医肾藏功能态势测评报告")
], -1)
const _hoisted_25 = { class: "card" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "title bgblue subpadding" }, [
  /*#__PURE__*/_createVNode("div", { class: "t" }, "中医脾藏功能态势测评报告")
], -1)
const _hoisted_27 = { class: "skeletonbox" }
const _hoisted_28 = { class: "imeibox clearfix" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "version fl" }, "报告版本：V7.0", -1)
const _hoisted_30 = { class: "version fr" }
const _hoisted_31 = { class: "footer clearfix" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_ReportVersion7 = _resolveComponent("ReportVersion7")
  const _component_van_skeleton = _resolveComponent("van-skeleton")
  const _component_PersonInfoToast = _resolveComponent("PersonInfoToast")
  const _component_Disclaimers = _resolveComponent("Disclaimers")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")

  return (_openBlock(), _createBlock(_component_van_pull_refresh, {
    modelValue: _ctx.loading,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = $event)),
    onRefresh: _ctx.onRefresh
  }, {
    default: _withId(() => [
      _withDirectives(_createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_van_image, {
                round: "",
                width: "1.45rem",
                height: "1.45rem",
                src: _ctx.heartReportData?.userAvatar ?? _ctx.avatarDefault
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.heartReportData?.userName ?? '-'), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              (_ctx.heartReportData.sex)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_ctx.heartReportData?.sex != '女')
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 0,
                          src: require('@/assets/img/health/female.png'),
                          class: "sexicon"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_van_image, {
                          key: 1,
                          src: require('@/assets/img/health/male.png'),
                          class: "sexicon"
                        }, null, 8, ["src"]))
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.heartReportData?.detectionTime), 1),
              _hoisted_11
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.heartReportData?.reportTime), 1),
              _hoisted_14
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createTextVNode(_toDisplayString(_ctx.heartReportData?.detectionTimeLength ? Number(_ctx.heartReportData.detectionTimeLength).toFixed(2) : ''), 1),
                _hoisted_17
              ]),
              _hoisted_18
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_ReportVersion7, { data: _ctx.heartReportData }, null, 8, ["data"])
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_ReportVersion7, { data: _ctx.liverReportData }, null, 8, ["data"])
        ]),
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode(_component_ReportVersion7, { data: _ctx.kidneyReportData }, null, 8, ["data"])
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_ReportVersion7, { data: _ctx.spleenReportData }, null, 8, ["data"])
        ])
      ], 512), [
        [_vShow, _ctx.heartReportData]
      ]),
      _withDirectives(_createVNode("div", _hoisted_27, [
        _createVNode(_component_van_skeleton, {
          title: "",
          avatar: "",
          row: 1
        }),
        _createVNode(_component_van_skeleton, {
          title: "",
          row: 5
        }),
        _createVNode(_component_van_skeleton, {
          title: "",
          row: 5
        })
      ], 512), [
        [_vShow, !_ctx.heartReportData]
      ]),
      _createVNode("div", _hoisted_28, [
        _hoisted_29,
        _createVNode("div", _hoisted_30, "设备编号：" + _toDisplayString(_ctx.heartReportData?.imei ?? '-'), 1)
      ]),
      _createVNode("div", _hoisted_31, [
        (_ctx.heartReportData?.expertId === '103')
          ? (_openBlock(), _createBlock(_component_PersonInfoToast, {
              key: 0,
              title: "健康报告专家授权：",
              person: "王义国"
            }))
          : (_openBlock(), _createBlock(_component_PersonInfoToast, {
              key: 1,
              title: "健康报告专家授权：",
              person: "张启明"
            }))
      ]),
      _createVNode(_component_Disclaimers, { padding: "0 0.4rem 0.4rem" })
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
})